import axios from 'axios';
import moment from 'moment';
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router';
import styled from 'styled-components';
import { API_URL } from '../ConstVariable';
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from 'devextreme-react';

const BPBrokerHealth = () => {
    const { getAccessTokenSilently, user } = useAuth0();
    const { center_prefix } = useParams()
    document.title = `Broker health:${center_prefix}`
    const [isOnline, setIsOnline] = useState(true)
    const [isRefreshing, setIsRefreshing] = useState(false)
    const [healthData, setHealthData] = useState(null)
    const [restartDisabled, setRestartDisabled] = useState(!(user.profile && user.profile.toLowerCase() == "oi-admin"))
    let token = localStorage.getItem("MyToken");
    let interval = null;
    const Table = styled.table` border: 1px solid black;
    border-collapse: collapse;
    text-align: center;
    background-color: lightgrey;
    margin: 5px;
    padding: 5px;
    padding-left: 20px;
    padding-right: 20px;`;

    const TH = styled.th` border: 1px solid black;
    border-collapse: collapse;
    text-align: center;
    background-color: lightgrey;
    margin: 5px;
    padding: 5px;
    padding-left: 20px;
    padding-right: 20px;`;

    const TR = styled.tr` border: 1px solid black;
    border-collapse: collapse;
    text-align: center;
    background-color: lightgrey;
    margin: 5px;
    padding: 5px;
    padding-left: 20px;
    padding-right: 20px;`;

    const TD = styled.td` border: 1px solid black;
    border-collapse: collapse;
    background-color: white;
    margin: 5px;
    padding: 5px;`;

    const RedDot = styled.div`
        height: 15px;
        width: 15px;
        background-color: red;
        border-radius: 50%;
        display: inline-block;`;

    const GreenDot = styled.div`
        height: 15px;
        width: 15px;
        background-color: green;
        border-radius: 50%;
        display: inline-block;`

    const fetchHealthCheckData = () => {
        axios({
            method: "get",
            url: `${API_URL}/oi/api/health-check/${center_prefix}`,
            // data: request_data,
            headers: {

                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            withCredentials: true
        }).then((response) => {
            setIsRefreshing(false);
            setIsOnline(true);
            setHealthData(response.data)
        })
            .catch((error) => {
                setIsRefreshing(false);
                setIsOnline(false);
                setHealthData(null)
                console.log("Error", error)
            });
    }

    const restartBroker = () => {
        // alert("Restart broker");
        if (user.profile && user.profile.toLowerCase() == "oi-admin")
            setRestartDisabled(true)
        clearInterval(interval);
        interval = null;
        axios({
            method: "get",
            url: `${API_URL}/oi/api/health-check/restart/${center_prefix}`,
            // data: request_data,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            withCredentials: true
        }).then((response) => {
            if (interval == null)
                interval = setInterval(Refresh, 10000);
        }).catch((error) => {
            console.log("Error", error)
        });

    }
    const Refresh = () => {
        setIsRefreshing(true);
        if (user.profile && user.profile.toLowerCase() == "oi-admin") {
            setRestartDisabled(false)
        }
        fetchHealthCheckData();
    }
    useEffect(() => {
        fetchHealthCheckData()
        if (interval == null)
            interval = setInterval(Refresh, 10000);
    }, [])

    const DBRow = (e) => {
        return (<TR><TD>{e.obj.connection_id}</TD>
            {e.obj.is_free == true && <TD><GreenDot></GreenDot></TD>}
            {e.obj.is_free == false && <TD><RedDot></RedDot></TD>}
            <TD style={{ width: "60vw" }}>{e.obj?.running_query}</TD>
            {e.obj?.query_start_time != null && <TD>{moment(e.obj?.query_start_time).format("DD-MM-YYYY hh:mm:ss a")}</TD>}
            {e.obj?.query_start_time == null && <TD></TD>}
            <TD>{e.obj?.time_elapsed}</TD></TR>);
    }
    const RunningRequest = (e) => {
        console.log(e)
        return (<TR><TD>{e.obj.conversation_id}</TD>
            <TD>{e.obj.path}</TD>
            {e.obj?.started_on != null && <TD>{moment(e.obj?.started_on).format("DD-MM-YYYY hh:mm:ss a")}</TD>}
            {e.obj?.started_on == null && <TD></TD>}
        </TR>);
    }
    return (
        <div style={{ margin: "5px" }}>
            <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                <div style={{ width: "70%", textAlign: "left", display: "flex" }}><h3>Broker: {center_prefix}</h3>
                    <div style={{ marginLeft: "10px", alignSelf: "center" }}>{isOnline == true && <div><GreenDot></GreenDot>Online</div>}
                        {isOnline == false && <div><RedDot></RedDot>Offline</div>}</div>
                </div>

                <div style={{ width: "30%", textAlign: "right" }}> {isRefreshing && `Refreshing...`}
                    {!isRefreshing && `Updated on: ${moment().format("DD-MM-YYYY hh:mm:ss a")}`} </div>
            </div>
            {healthData && <>
                <hr></hr>
                <div>
                    DB Connection Status
                    {healthData && <Table style={{ border: "1px solid gray" }}>
                        <TR>
                            <TH>Conn#</TH>
                            <TH>Is Free</TH>
                            <TH>Running Query</TH>
                            <TH>Start time</TH>
                            <TH>Time elapsed(seconds)</TH>
                        </TR>
                        {
                            healthData?.db_status.map((object, i) => <DBRow key={i} obj={object}></DBRow>)
                        }
                    </Table>}
                </div>
                <hr></hr>
                <div>
                    Running HTTP requests
                    {healthData && <Table style={{ border: "1px solid gray" }}>
                        <TR>
                            <TH>conversation id#</TH>
                            <TH style={{ width: "70vw" }}>Path</TH>
                            <TH>Started On</TH>
                        </TR>
                        {
                            Object.keys(healthData.running_requests).map((obj, index) => (<RunningRequest key={index} obj={healthData.running_requests[obj]}></RunningRequest>))
                        }
                    </Table>}
                </div>
                <hr></hr>
                <div><pre>{healthData?.version}</pre></div>
                <hr></hr>
                {user && user?.can_restart_broker && <div>
                    <Button disabled={restartDisabled} text='Restart broker' stylingMode="contained" type="danger" onClick={() => { restartBroker() }}></Button>
                </div>}
            </>
            }
        </div>
    )
}

export default BPBrokerHealth